/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentEventSeverities } from './equipment-event-severities';


export interface EquipmentEventHistoryResponse { 
    id: string;
    workerName: string;
    isUnknownWorker: boolean;
    categoryName: string;
    severity: EquipmentEventSeverities;
    description: string;
    ipAddress: string;
    createdDate: string;
}



